import { authenticatedFetch } from '../../../shared/utils/authenticatedFetch';
import type { BottleneckRadarData } from '../types/taBottleneck';

const PROXY_URL =
  import.meta.env.VITE_PROXY_URL ||
  'https://proxy-prod-520260363689.europe-west3.run.app';

/**
 * The radar's live measures.
 *
 * Reads two systems the proxy joins for us — DWH2 for the funnel and the `hiring_plan` Airtable for
 * how many hires each posting is actually for. A failure in either is one failure to the caller:
 * the radar cannot be drawn from half of it, because coverage needs both halves.
 */
export async function fetchBottleneckRadar(
  conversionWindowDays?: number
): Promise<BottleneckRadarData> {
  const q =
    conversionWindowDays === undefined ? '' : `?windowDays=${encodeURIComponent(conversionWindowDays)}`;
  const res = await authenticatedFetch(`${PROXY_URL}/api/recruiting/bottleneck-radar${q}`);
  if (!res.ok) {
    let detail = '';
    try {
      const body = await res.json();
      detail = body?.error || body?.message || '';
    } catch {
      /* a non-JSON error body tells us nothing useful */
    }
    throw new Error(detail || `Request failed (${res.status})`);
  }
  return res.json() as Promise<BottleneckRadarData>;
}
